import * as AT from './actionTypes'
import { WithdrawalRequest, WithdrawalResponse } from './types'

export type WithdrawalActionType =
  | { payload: WithdrawalRequest; type: typeof AT.SUBMIT }
  | { payload: WithdrawalResponse; type: typeof AT.SUBMIT_SUCCESS }
  | { type: typeof AT.SUBMIT_ERROR }
  | { type: typeof AT.RESET }

const submit = (request: WithdrawalRequest): WithdrawalActionType => ({
  payload: request,
  type: AT.SUBMIT
})

const submitSuccess = (response: WithdrawalResponse) => ({
  payload: response,
  type: AT.SUBMIT_SUCCESS
})

const submitError = () => ({
  type: AT.SUBMIT_ERROR
})

const reset = () => ({
  type: AT.RESET
})

export default { reset, submit, submitError, submitSuccess }
